import React from 'react';
import { UFBNoticeClickEvent } from '@udemy/browse-event-tracking';
import { Tracker } from '@udemy/event-tracking';
import { Icon } from '@udemy/icons';
import { Button } from '@udemy/react-core-components';
import { LearningTestimonialCard, LearningTestimonialType, LearningTestimonialsUnit, TestimonialClickEvent, getTestimonialEventTypeFromSchemaType } from '@udemy/react-discovery-units';
import { safelySetInnerHTML } from '@udemy/shared-utils';
import { DynamicWebContentPageType, useDynamicWebContentTestimonialsQuery } from '../graphql/api-platform-graphql';
import { useDynamicWebContentQueryParams } from './hooks/useDynamicWebContentQueryParams';
import { getDynamicWebContentQueryParams, isInternalUrl } from './utils';
function mapTestimonialsData(testimonialsData) {
  return {
    heading: testimonialsData.heading,
    contents: testimonialsData.contents.map(mapTestimonialData)
  };
}
function mapTestimonialData(testimonialData) {
  var _testimonialData$cont, _testimonialData$cont2, _testimonialData$cont3;
  return {
    relatedUrl: testimonialData === null || testimonialData === void 0 ? void 0 : testimonialData.contentUrl,
    relatedUrlText: testimonialData === null || testimonialData === void 0 ? void 0 : testimonialData.contentUrlText,
    content: testimonialData === null || testimonialData === void 0 ? void 0 : testimonialData.description,
    id: testimonialData === null || testimonialData === void 0 ? void 0 : testimonialData.trackingId,
    source: {
      description: testimonialData === null || testimonialData === void 0 || (_testimonialData$cont = testimonialData.contents) === null || _testimonialData$cont === void 0 || (_testimonialData$cont = _testimonialData$cont[0]) === null || _testimonialData$cont === void 0 ? void 0 : _testimonialData$cont.description,
      image: testimonialData === null || testimonialData === void 0 || (_testimonialData$cont2 = testimonialData.contents) === null || _testimonialData$cont2 === void 0 || (_testimonialData$cont2 = _testimonialData$cont2[0]) === null || _testimonialData$cont2 === void 0 || (_testimonialData$cont2 = _testimonialData$cont2.image) === null || _testimonialData$cont2 === void 0 ? void 0 : _testimonialData$cont2.url,
      name: testimonialData === null || testimonialData === void 0 || (_testimonialData$cont3 = testimonialData.contents) === null || _testimonialData$cont3 === void 0 || (_testimonialData$cont3 = _testimonialData$cont3[0]) === null || _testimonialData$cont3 === void 0 ? void 0 : _testimonialData$cont3.heading
    },
    type: testimonialData === null || testimonialData === void 0 ? void 0 : testimonialData.labelText
  };
}
function handleContentUrlClick(testimonial, url) {
  if (testimonial.type === LearningTestimonialType.ThirdParty) {
    Tracker.publishEvent(new TestimonialClickEvent({
      id: testimonial.id,
      type: getTestimonialEventTypeFromSchemaType(testimonial.type),
      url: url !== null && url !== void 0 ? url : null,
      uiRegion: 'body'
    }));
  }
}
function handleButtonClick(testimonial) {
  Tracker.publishEvent(new TestimonialClickEvent({
    id: testimonial.id,
    type: getTestimonialEventTypeFromSchemaType(testimonial.type),
    url: testimonial.relatedUrl,
    uiRegion: 'body'
  }));
  if (testimonial.type === LearningTestimonialType.CaseStudy) {
    Tracker.publishEvent(new UFBNoticeClickEvent({
      url: testimonial.relatedUrl,
      placement: 'body'
    }));
  }
}
export function validateTestimonialData(data) {
  var _data$dynamicWebConte, _data$dynamicWebConte2, _data$dynamicWebConte3, _dynamicWebContent$co;
  if (!(data !== null && data !== void 0 && (_data$dynamicWebConte = data.dynamicWebContent) !== null && _data$dynamicWebConte !== void 0 && _data$dynamicWebConte.heading)) {
    return false;
  }
  if (!(data !== null && data !== void 0 && (_data$dynamicWebConte2 = data.dynamicWebContent) !== null && _data$dynamicWebConte2 !== void 0 && _data$dynamicWebConte2.contents) || !(data !== null && data !== void 0 && (_data$dynamicWebConte3 = data.dynamicWebContent) !== null && _data$dynamicWebConte3 !== void 0 && _data$dynamicWebConte3.contents.length)) {
    return false;
  }
  const {
    dynamicWebContent
  } = data;
  return (_dynamicWebContent$co = dynamicWebContent.contents) === null || _dynamicWebContent$co === void 0 ? void 0 : _dynamicWebContent$co.every(testimonial => {
    var _testimonial$contents, _testimonial$contents2, _testimonial$contents3;
    return (testimonial === null || testimonial === void 0 ? void 0 : testimonial.contentUrl) && (testimonial === null || testimonial === void 0 ? void 0 : testimonial.contentUrlText) && (testimonial === null || testimonial === void 0 ? void 0 : testimonial.description) && (testimonial === null || testimonial === void 0 ? void 0 : testimonial.labelText) && (testimonial === null || testimonial === void 0 ? void 0 : testimonial.trackingId) && (testimonial === null || testimonial === void 0 || (_testimonial$contents = testimonial.contents) === null || _testimonial$contents === void 0 || (_testimonial$contents = _testimonial$contents[0]) === null || _testimonial$contents === void 0 ? void 0 : _testimonial$contents.description) && (testimonial === null || testimonial === void 0 || (_testimonial$contents2 = testimonial.contents) === null || _testimonial$contents2 === void 0 || (_testimonial$contents2 = _testimonial$contents2[0]) === null || _testimonial$contents2 === void 0 ? void 0 : _testimonial$contents2.heading) && (testimonial === null || testimonial === void 0 || (_testimonial$contents3 = testimonial.contents) === null || _testimonial$contents3 === void 0 || (_testimonial$contents3 = _testimonial$contents3[0]) === null || _testimonial$contents3 === void 0 || (_testimonial$contents3 = _testimonial$contents3.image) === null || _testimonial$contents3 === void 0 ? void 0 : _testimonial$contents3.url);
  });
}
export const TestimonialsCMSWrapper = ({
  className,
  showCta = false,
  ctaHref,
  ctaLabel,
  ctaOnClick,
  titleClassName = 'ud-heading-serif-xxl'
}) => {
  var _response$data;
  const queryArgs = useDynamicWebContentQueryParams({
    ...getDynamicWebContentQueryParams(),
    pageType: DynamicWebContentPageType.LoggedOutHomePage
  });
  const response = useDynamicWebContentTestimonialsQuery(queryArgs);
  if (!validateTestimonialData(response === null || response === void 0 ? void 0 : response.data)) {
    return null;
  }
  const data = mapTestimonialsData(response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.dynamicWebContent);
  return /*#__PURE__*/React.createElement(LearningTestimonialsUnit, {
    className: className,
    title: data.heading,
    titleClassName: titleClassName,
    titleId: "testimonials-unit-title",
    showCta: showCta,
    ctaHref: ctaHref,
    ctaLabel: ctaLabel,
    ctaOnClick: ctaOnClick
  }, data.contents.map(testimonial => {
    return /*#__PURE__*/React.createElement(LearningTestimonialCard, {
      content: testimonial.content,
      contentUrlOnClick: url => handleContentUrlClick(testimonial, url),
      id: testimonial.id,
      key: testimonial.id,
      relatedUrl: testimonial.relatedUrl,
      relatedUrlText: testimonial.relatedUrlText,
      type: testimonial.type,
      source: testimonial.source,
      uiRegion: "body"
    }, /*#__PURE__*/React.createElement(Button, {
      componentClass: "a",
      href: testimonial.relatedUrl,
      onClick: () => handleButtonClick(testimonial),
      size: "small",
      target: isInternalUrl(testimonial.relatedUrl) ? undefined : '_blank',
      udStyle: "link"
    }, /*#__PURE__*/React.createElement("span", safelySetInnerHTML({
      descriptionOfCaller: 'testimonial:related_url_text',
      html: testimonial.relatedUrlText
    })), /*#__PURE__*/React.createElement(Icon, {
      glyph: "next",
      label: false,
      size: "xsmall"
    })));
  }));
};
//# sourceMappingURL=testimonials-cms-wrapper.react-component.js.map